/**
 * Implementation of subscription PricingCard
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React, { ReactNode } from "react";
import { PaddleProduct } from "../../globals/contants";
import PurchaseLTD from "./Purchase";

type Props = {
  planName: string;
  planId: number;
  price: string;
  features: ReactNode;
  highligted?: boolean;
};

export default function PricingCard(props: Props) {
  return (
    <div
      className={`rounded-lg bg-white border-0 shadow-xl overflow-hidden w-[350px] ${
        props.highligted ? "border border-[#FF8C00]" : ""
      } `}
    >
      {props.highligted && (
        <div className="text-center uppercase rounded-tl-lg rounded-tr-lg p-1 bg-gradient-to-r from-[#40E0D0] via-[#FF8C00] to-[#FF0080] text-sm text-primary font-bold">
          Most Popular
        </div>
      )}
      <div className="bg-gray-100 flex flex-col items-center py-5">
        <p className="text-primary mb-6">{props.planName}</p>
        <p className="text-5xl text-primary font-bold text-center">
          {props.price}
          <span className="text-base text-gray-500">/month</span>
        </p>
      </div>

      <div className="mt-10 px-10 lg:px-12 pb-10 flex flex-col items-start">
        {props.features}
      </div>

      <div className="flex flex-col justify-center items-center p-4 cursor-pointer pb-10">
        <PurchaseLTD
          planId={props.planId}
          cta={<button className="btn-primary px-10">Choose Plan</button>}
        />
        {/* <p className="text-gray-500 text-sm mt-1">7 day Free Trial</p> */}
      </div>
    </div>
  );
}
